import {
  ActivityActionsType,
  SET_ACTIVITIES
} from './actions';
import {
  IActivityInitialState,
  IActivityXpedition,
  IActivityActionHandler
} from './interfaces';

const ActivityInitialState: IActivityInitialState = {
  activities: []
};

const setActivities = ({
  state,
  payload
}: IActivityActionHandler): IActivityInitialState => {
  return {
    ...state,
    activities: payload as IActivityXpedition[]
  };
};

const activityReducerHandlers = new Map([
  [SET_ACTIVITIES, setActivities]
]);

const activityReducer = (state = ActivityInitialState, action: ActivityActionsType): IActivityInitialState => {
  const handler = activityReducerHandlers.get(action.type);

  return (handler && {
    ...handler(<IActivityActionHandler>{
      state,
      payload: action.payload
    })
  }) || {...state};
};

export default activityReducer;
